import { atlas } from './directions/atlas.js';
import { ledger } from './directions/ledger.js';
import { noir } from './directions/noir.js';
export * from './checks.js';
export * from './color-math.js';
export * from './css.js';
export * from './palette.js';
export * from './shared.js';
export * from './types.js';
export { atlas, ledger, noir };
/**
 * The three directions, in the switcher's order. Grimoire Noir is the default
 * (`DEFAULT_DIRECTION`, the GM's choice of 2026-09-28).
 */
export const DIRECTIONS = [atlas, ledger, noir];
export function directionById(id) {
    const found = DIRECTIONS.find((d) => d.id === id);
    if (!found)
        throw new RangeError(`unknown direction "${String(id)}"`);
    return found;
}
//# sourceMappingURL=index.js.map